import { useEffect } from 'react';

/**
 * Custom hook that observes a ref element and adds 'revealed' class
 * when it scrolls into the viewport.
 * @param {React.RefObject} ref - ref to the element to observe
 */
const useScrollReveal = (ref) => {
    useEffect(() => {
        const element = ref.current;
        if (!element) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('revealed');
                    observer.unobserve(entry.target);
                }
            },
            {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px',
            }
        );

        observer.observe(element);

        return () => observer.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useScrollReveal;
